import React, { Component } from 'react'
import Wrapper from './Wrapper';

class RemountHack extends Component {
  render() {
    return (
      <Wrapper className="RemountHack">
      </Wrapper>
    )
  }
}

export default RemountHack;




/** WEBPACK FOOTER **
 ** ./src/components/RemountHack.js
 **/